var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 760,
    height: 840,
    viewBox: "0 0 760 840",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5923_12467)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 760,
    height: 840,
    transform: "matrix(1 0 0 -1 0 840)",
    fill: "url(#paint0_linear_5923_12467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2871 1068.52C400.135 895.228 530.44 704.118 577.663 559.138C630.363 397.334 603.185 220.49 660.073 209.507C696.5 202.473 741.321 268.508 824.886 413.267C1078.3 852.228 1084.03 968.8 1192 999.055C1343.24 1041.47 1436.48 841.932 1668.96 846.233C1839.71 849.399 1977.88 960.498 2071.01 1059.25",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11719 1051.1C380.213 881.538 518.003 695.775 568.972 559.898C625.928 408.052 599.029 240.343 655.325 232.411C691.519 227.308 735.498 292.214 816.217 432.012C1061.53 856.793 1069.14 974.816 1176.27 1003.58C1328.39 1043.84 1417.56 829.873 1652.51 826.96C1657.63 826.896 1662.68 826.896 1667.72 827.023C1834.42 831.324 1974.56 942.476 2069.68 1040.62",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0214844 1033.68C360.295 867.864 505.461 687.763 560.305 560.669C621.434 419.003 594.916 260.217 650.604 255.325C686.575 252.159 729.718 315.941 807.568 450.773C1044.73 861.352 1054.17 981.206 1160.59 1008.1C1313.45 1046.73 1398.74 817.708 1636.1 807.681C1641.31 807.459 1646.5 807.238 1651.69 807.264C1821.14 808.13 1968.57 921.577 2068.38 1021.99",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.18164 1016.26C340.406 854.144 492.72 680.139 551.623 561.44C616.753 430.186 590.81 280.109 645.86 278.246C681.626 277.032 723.881 339.664 798.903 469.529C1027.94 865.955 1039.24 987.387 1144.89 1012.62C1298.56 1049.33 1379.92 805.455 1619.68 788.404C1625 788.024 1630.32 787.66 1635.62 787.501C1807.81 782.404 1962.53 900.675 2067.04 1003.35",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.3398 998.839C320.496 840.47 479.726 672.919 542.938 562.21C611.807 441.596 586.729 300.02 641.124 301.165C676.692 301.909 718.07 363.39 790.246 488.29C1011.16 870.535 1024.33 993.551 1129.19 1017.14C1283.72 1051.91 1361.14 793.111 1603.26 769.104C1608.7 768.576 1614.14 768.049 1619.59 767.721C1794.52 758 1956.54 879.76 2065.76 984.711",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.4961 981.418C300.594 826.791 466.403 666.137 534.271 562.986C606.487 453.217 582.65 319.947 636.402 324.079C671.781 326.802 712.266 387.112 781.596 507.051C994.39 875.116 1009.44 999.694 1113.51 1021.66C1268.89 1054.46 1342.37 780.683 1586.85 749.842C1592.41 749.14 1597.96 748.427 1603.56 747.974C1781.22 733.672 1950.57 858.872 2064.47 966.093",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36.6484 963.997C280.684 813.096 452.647 659.788 525.579 563.756C600.613 464.953 578.603 339.9 631.655 346.998C666.858 351.706 706.443 410.854 772.922 525.806C977.594 879.691 994.544 1005.82 1097.8 1026.18C1254.06 1056.99 1323.58 768.18 1570.42 730.563C1576.11 729.697 1581.77 728.811 1587.5 728.214C1767.86 709.364 1944.54 837.984 2063.14 947.458",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45.8066 946.577C260.775 799.407 421.479 638.379 516.899 564.527C574.692 464.748 574.55 359.881 626.919 369.914C661.945 376.626 700.632 434.561 764.264 544.595C960.809 884.299 979.654 1011.95 1082.1 1030.73C1239.24 1059.53 1304.8 755.631 1553.99 711.312C1559.79 710.283 1565.59 709.227 1571.46 708.478C1754.55 685.126 1938.57 817.097 2061.84 928.851",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-54.9648 929.156C240.871 785.717 405.917 628.979 508.219 565.297C566.741 474.379 570.497 379.887 622.183 392.833C657.039 401.562 694.815 458.272 755.602 563.329C943.995 888.853 964.776 1018.02 1066.41 1035.23C1224.43 1061.98 1286.01 742.96 1537.57 692.007C1543.48 690.809 1549.4 689.585 1555.41 688.687C1741.23 660.87 1932.54 796.172 2060.53 910.189",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64.123 911.735C220.961 772.027 390.35 619.59 499.533 566.067C558.784 484.004 566.445 399.914 617.448 415.747C652.127 426.507 689.003 481.999 746.939 582.084C927.239 893.449 949.903 1024.08 1050.71 1039.74C1209.63 1064.43 1267.2 730.251 1521.15 672.718C1527.17 671.356 1533.22 669.968 1539.37 668.918C1727.91 636.663 1926.54 775.262 2059.22 891.549",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-73.2754 894.315C201.063 758.338 374.789 610.197 490.854 566.843C550.832 493.641 562.386 419.974 612.706 438.667C647.209 451.48 683.192 505.731 738.281 600.83C910.454 897.998 935.036 1030.12 1035.01 1044.25C1194.83 1066.84 1248.38 717.481 1504.73 653.429C1510.87 651.894 1517.04 650.353 1523.31 649.144C1714.61 612.482 1920.53 754.354 2057.92 872.905",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-82.4333 876.889C181.142 744.654 359.239 600.804 482.179 567.635C542.887 503.294 558.322 440.065 607.965 461.608C642.28 476.49 677.375 529.475 729.613 619.628C893.664 902.617 920.164 1036.18 1019.32 1048.8C1180.05 1069.28 1229.55 704.72 1488.31 634.188C1494.57 632.484 1500.83 630.779 1507.27 629.439C1701.3 588.391 1914.53 733.503 2056.61 854.323",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-91.5918 859.468C161.237 730.964 343.655 591.409 473.493 568.384C534.929 512.903 554.23 460.14 603.235 484.5C637.351 501.462 671.563 553.18 720.955 638.367C876.907 907.176 905.308 1042.17 1003.61 1053.31C1165.26 1071.61 1210.68 691.832 1471.89 614.888C1478.26 613.01 1484.67 611.152 1491.24 609.637C1688.03 564.252 1908.54 712.546 2055.31 835.657",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-100.73 842.048C141.33 717.275 328.091 582.021 464.816 569.165C526.974 522.545 550.128 480.247 598.501 507.42C632.412 526.471 665.754 576.902 712.3 657.123C860.107 911.756 890.449 1048.18 987.919 1057.83C1150.48 1073.95 1191.8 678.913 1455.47 595.61C1461.95 593.557 1468.49 591.541 1475.18 589.874C1674.73 540.14 1902.52 691.664 2054.02 817.022",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109.9 824.627C121.42 703.585 312.529 572.628 456.135 569.931C519.022 532.171 546.012 500.359 593.765 530.351C627.454 551.497 659.942 600.635 703.614 675.895C843.299 916.348 875.565 1054.15 972.198 1062.36C1135.68 1076.25 1172.87 666.026 1439.02 576.338C1445.62 574.116 1452.28 571.947 1459.11 570.121C1661.44 516.07 1896.49 670.776 2052.66 798.399",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-119.057 807.206C101.512 689.896 296.964 563.233 447.451 570.701C511.073 541.802 541.876 520.481 589.031 553.254C622.487 576.506 654.127 624.351 694.982 694.645C826.539 920.913 860.728 1060.09 956.531 1066.87C1120.93 1078.51 1153.96 653.039 1422.63 557.075C1429.34 554.679 1436.13 552.357 1443.12 550.378C1648.2 492 1890.51 649.862 2051.38 779.732",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128.217 789.786C81.6062 676.212 281.395 553.861 438.769 571.472C503.085 551.418 537.719 540.615 584.294 576.174C617.499 601.532 648.314 648.073 686.317 713.386C809.752 925.473 845.865 1066 940.831 1071.37C1106.14 1080.71 1135 640.025 1406.2 537.749C1413.03 535.174 1419.94 532.704 1427.04 530.567C1634.95 467.956 1884.52 628.964 2050.07 761.12",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.373 772.344C61.6984 662.501 265.83 544.43 430.085 572.226C495.158 561.044 533.548 560.722 579.548 599.067C612.503 626.509 642.498 671.773 677.65 732.141C792.963 930.043 831 1071.92 925.129 1075.89C1091.37 1082.92 1116.02 627.027 1389.78 518.503C1396.72 515.748 1403.76 513.13 1410.99 510.835C1621.72 443.933 1878.5 608.07 2048.76 742.511",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-146.525 754.929C41.7889 648.854 248.106 601.321 421.411 573.018C486.262 562.426 529.371 580.876 574.819 622.008C607.506 651.561 636.693 695.522 668.998 750.924C776.184 934.655 816.139 1077.84 909.437 1080.43C1076.58 1085.07 1097.02 613.981 1373.36 499.209C1380.41 496.285 1387.59 493.515 1394.95 491.061C1608.49 419.906 1872.48 587.161 2047.46 723.851",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-155.684 737.513C21.8962 635.132 230.78 540.52 412.731 573.778C478.367 585.778 525.17 600.993 570.083 644.916C602.491 676.581 630.875 719.232 660.335 769.674C759.404 939.225 801.267 1083.71 893.739 1084.94C1061.78 1087.18 1077.98 600.909 1356.94 479.92C1364.1 476.816 1371.41 473.914 1378.9 471.291C1595.44 396.294 1866.49 566.257 2046.16 705.216",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164.842 720.098C1.97507 621.448 216.619 523.653 404.051 574.553C470.535 592.612 520.958 621.126 565.347 667.836C597.465 701.611 625.064 742.965 651.672 788.435C742.619 943.811 786.394 1089.95 878.041 1089.47C1046.98 1088.58 1058.73 587.462 1340.52 460.647C1347.78 457.353 1355.23 454.315 1362.85 451.532C1582.16 372.103 1860.48 545.354 2044.84 686.576",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-174 702.683C-17.9347 607.77 203.568 506.893 395.365 575.335C684.501 678.529 709.516 1096.42 862.349 1093.99C1036.57 1091.22 1040.13 547.576 1346.81 431.775C1568.88 347.917 1854.5 524.456 2043.53 667.953",
    stroke: "white",
    strokeOpacity: 0.025,
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5923_12467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M780.778 -10.5704L772.557 -7.98483L772.832 -7.93437L745.671 31.8367L683.737 19.9456L673.052 23.3058C670.911 29.5277 676.743 38.665 681.871 39.6165L757.405 53.0241L791.513 3.54081C785.685 4.26279 777.609 0.195031 780.78 -10.5673L780.778 -10.5704ZM741.453 35.9869L678.275 24.4894L679.358 23.7111L741.843 34.5847L741.45 35.9891L741.453 35.9869ZM756.766 51.4455C756.766 51.4455 747.549 49.1959 748.442 36.7454L777.527 -5.77919C777.527 -5.77919 778.589 5.24155 787.183 6.02061L756.768 51.4487L756.766 51.4455ZM683.737 19.9456L681.622 19.5389L708.922 -19.8457L772.557 -7.98483L780.775 -10.5682C780.761 -10.5204 780.748 -10.4726 780.735 -10.4248L781.31 -11.2582L706.495 -24.8731L673.26 23.2371L683.732 19.9447L683.737 19.9456Z",
    fill: "white",
    fillOpacity: 0.12
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5923_12467",
    x1: 760,
    y1: 840,
    x2: -49,
    y2: -138.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434733,
    stopColor: "#006AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003580"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5923_12467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2245.01,
    height: 1166,
    fill: "white",
    transform: "translate(-174 -72)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5923_12467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "white",
    transform: "translate(642 0.39856) rotate(-35.7225)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/loginImage.e285b4083413123a763d1d1d915a9e53.svg";
export { ForwardRef as ReactComponent };